// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ui-0";